import { atom } from 'jotai';
import type { StickyZoneId, ViewId } from 'balus-common';

type DropTarget = {
  viewId: ViewId;
  stickyZoneIds: StickyZoneId[]; // viewIdが示すビューの中にあるゾーンのID
};

// ドラッグで要素を移動している時に、ドロップできるビューやゾーンを示すためのatom
export const dropTargetViewAtom = atom<null | DropTarget>(null);
